import { TriState } from "./Enums";

export class TradeSearchParameters {
    pageNumber: number = 0;
    searchText: string = "";
    id: number = 0;
    regionID: number = 0;
    isDeleted: TriState = TriState.UseDefault;
    buyerID: number = 0;
}